import React from 'react';
import CellFactory from '../../CellFactory';

const EdexcelALevel = ({ row }) => {
  const {
    columnOne,
    columnTwo,
    columnThree,
    columnFour,
    columnFive,
    columnSix,
    columnSeven,
    columnEight,
    columnNine,
    columnTen,
  } = row;

  return (
    <tr>
      <td>{columnOne}</td>
      <td>
        <CellFactory cells={columnTwo} />
      </td>
      <td>
        <CellFactory cells={columnThree} />
      </td>
      <td>
        <CellFactory cells={columnFour} />
      </td>
      <td>
        <CellFactory cells={columnFive} />
      </td>
      <td>
        <CellFactory cells={columnSix} />
      </td>
      <td>
        <CellFactory cells={columnSeven} />
      </td>
      <td>
        <CellFactory cells={columnEight} />
      </td>
      <td>
        <CellFactory cells={columnNine} />
      </td>
      <td>
        <CellFactory cells={columnTen} />
      </td>
    </tr>
  );
};

export default EdexcelALevel;
